import { defineComponent as _defineComponent } from 'vue';
import { storeToRefs } from "pinia";
import { useBroadcastsStore } from "@/stores/broadcastsStore";
import BroadcastContainer from "@/components/Notifications/Broadcasts/BroadcastContainer.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BroadcastsOverlay',
    setup(__props) {
        const { activeBroadcasts } = storeToRefs(useBroadcastsStore());
        return { __sfc: true, activeBroadcasts, BroadcastContainer };
    }
});
